<div #focusElement class="calendar" tabindex="1" (focus)="onFocus()" (blur)="onBlur()">
  <div class="calendar__header">
    <button
      class            = "calendar__button"
      [disabled]       = "showYearsList"
      [class.disabled] = "showYearsList"
      (click)          = "onPreviousMonth()"
      (focus)          = "onFocus()"
      (blur)           = "onBlur()"
    >
      <flame-icon class="calendar__icon" svgIcon="chevron-left" size="s"></flame-icon>
    </button>
    <button class="calendar__select" (click)="onToggleYearsList()" (focus)="onFocus()" (blur)="onBlur()">
      {{ !onlyMonths ? ( ( monthsName[month] ?? '' ) + ' ' ) : '' }}{{ year }}
      <flame-icon
        size               = "s"
        class              = "calendar__select-icon"
        svgIcon            = "chevron-down"
        [class.rotate-180] = "showYearsList"
      ></flame-icon>
    </button>
    <button
      class            = "calendar__button"
      [disabled]       = "showYearsList"
      [class.disabled] = "showYearsList"
      (click)          = "onNextMonth()"
      (focus)          = "onFocus()"
      (blur)           = "onBlur()"
    >
      <flame-icon class="calendar__icon" svgIcon="chevron-right" size="s"></flame-icon>
    </button>
  </div>

  <div class="calendar__content">
    <ul class="calendar__years" #yearsUl [ngClass]="{ 'calendar__years-show_years':showYearsList }">
      <li
        *ngFor           = "let nyear of yearsList"
        [class.selected] = "nyear===year"
        (click)          = "onSelectYear(nyear)"
      >
        {{ nyear }}
      </li>
    </ul>
    <ul class="calendar__months" *ngIf="onlyMonths">
      <li
        *ngFor = "let nmonth of monthsName; let i=index"
      >
        <label [for]="'month-' + i">
          <input type="radio" [id]="'month-' + i" name="calendar__months" [value]="nmonth" [checked]="month===i" (click)="onSelectMonth(i)">
          {{ nmonth }}
        </label>
      </li>
    </ul>
    <div class="calendar__days">
      <div class="calendar__day" *ngFor="let day of daysOfWeek">{{ day }}</div>
    </div>
    <div class="calendar__dates">
      <div
        *ngFor                = "let day of calendarDays"
        class                 = "calendar__day"
        [class.is-day]        = "day.isDay"
        [class.is-last]       = "isLast(day.date)"
        [class.is-first]      = "isFirst(day.date)"
        [class.selected]      = "isSelectedDate(day.date)"
        [class.in-range]      = "isInRange(day.date)"
        [class.disabled]      = "day.disabled"
        [class.current-month] = "day.currentMonth"
        (click)               = "onSelectDate(day.date)"
      >
        {{ day.day }}
        <div class="select-view"></div>
      </div>
    </div>
  </div>
</div>
